import script from "./UserEditStoreAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditStoreAccess.vue?vue&type=script&setup=true&lang=js"

import "./UserEditStoreAccess.vue?vue&type=style&index=0&id=97f3319c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97f3319c"]])

export default __exports__